module.exports = __webpack_public_path__ + "static/media/energy.98de71c9.png";